import React from 'react';
import PropTypes from 'prop-types';

/**
 * Component to render success or failure messages.
 *
 * Generic messages have been used currently.
 *
 * @params See propTypes
 * @returns {JSX.Element}
 * @component
 */
const DonationProcessed = ({ globalPaymentsResponse }) => {
  if (!globalPaymentsResponse.AUTHCODE) {
    return window.location.href ="/donate/unsuccessful";

  } 
  return  window.location.href="/donate/successful";
};

DonationProcessed.propTypes = {
  /**
   * The response object returned from the Global Payments HPP.
   */
  globalPaymentsResponse: PropTypes.object.isRequired
};

export default DonationProcessed;
